import { render, staticRenderFns } from "./CreateCatalogSchema.vue?vue&type=template&id=8598a8de"
import script from "./CreateCatalogSchema.vue?vue&type=script&lang=js"
export * from "./CreateCatalogSchema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports